import { Icon } from '../../../../widgets/icon';
import { SkeletonBlock, SkeletonStack } from '../../../../widgets/skeleton';
import { ZTooltip } from '../../../../widgets/ztooltip';
import React, { FC, Suspense, useState } from 'react';
import styled, { css } from 'styled-components';

const Container = styled.div`
    display: flex;
    flex-direction: row;
    height: 100%;
    max-height: 100%;
    overflow: hidden;
`;

const MenuContainer = styled.div`
    width: 54px;
    height: 100%;
    background-color: #f6f8f9;
    padding-top: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const LeftVerticalToolbarContainer = styled.div<{ $hiddenSidebar?: boolean }>`
    flex: 1;
    height: 100%;
    padding: 24px 16px;
    background: #ffffff;
    max-height: 100%;
    ${(props) =>
        props.$hiddenSidebar &&
        css`
            background: none;
        `}
    overflow-y: auto;
`;

const MenuItemContainer = styled.button<{ $active?: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 12px 4px;
    cursor: pointer;
    margin: 0;
    border: 0;
    background: transparent;

    ${Icon} {
        width: 20px;
        height: 20px;
    }

    color: #1a1c1d;
    &:hover {
        color: #dc6843;
    }
    ${(props) =>
        props.$active &&
        css`
            color: #dc6843;
        `}
`;

const LoaderContainer = styled.div`
    width: 100%;
`;

const ToolbarPanelSkeleton = () => (
    <SkeletonStack aria-hidden='true' $gap='16px'>
        <SkeletonBlock $width='45%' $height='18px' />
        <SkeletonBlock $height='38px' $radius='8px' />
        <SkeletonBlock $height='38px' $radius='8px' />
        <SkeletonBlock $width='70%' $height='14px' $margin='8px 0 0' />
        <SkeletonBlock $height='96px' $radius='8px' />
    </SkeletonStack>
);

const TooltipV2 = styled(ZTooltip)`
    height: 20px;
    margin-left: 3px;
    svg {
        cursor: pointer;
        font-size: 20px;
        color: ${(props) => props.theme.app.secondary};
    }
`;

export interface StepsTools {
    tool: string;
    icon: React.ReactNode;
    tooltip: string;
    onClick: () => void;
    component: React.FC<any>;
}

export type LeftVerticalToolbarProps = {
    tools: StepsTools[];
    hiddenSidebar?: boolean;
};
const LeftVerticalToolbar: FC<LeftVerticalToolbarProps> = ({ tools, hiddenSidebar }) => {
    const [view, setView] = useState<string>(tools[0].tool);
    return (
        <Container>
            <MenuContainer>
                {tools.map((stepTool) => (
                    <TooltipV2 key={stepTool.tool} title={stepTool.tool} position='right' addContainer>
                        <MenuItemContainer
                            $active={view === stepTool.tool}
                            onClick={() => {
                                setView(stepTool.tool);
                                stepTool.onClick();
                            }}
                        >
                            <Icon>{stepTool.icon}</Icon>
                        </MenuItemContainer>
                    </TooltipV2>
                ))}
            </MenuContainer>
            <LeftVerticalToolbarContainer $hiddenSidebar={hiddenSidebar}>
                <Suspense
                    fallback={
                        <LoaderContainer>
                            <ToolbarPanelSkeleton />
                        </LoaderContainer>
                    }
                >
                    {tools.map((stepTool) => view === stepTool.tool && <stepTool.component key={stepTool.tool} />)}
                </Suspense>
            </LeftVerticalToolbarContainer>
        </Container>
    );
};

export default LeftVerticalToolbar;
